// Format attribute values for display
export const formatAttributeValues = (values) => {
    if (!values || !Array.isArray(values)) return '';
    
    return values.map(value => {
        if (typeof value === 'object' && value !== null) {
            return value.value || '';
        }
        return value;
    }).join(', ');
};

// Convert comma-separated string to array of values
export const stringToValues = (valuesString) => {
    if (!valuesString || typeof valuesString !== 'string') return [];
    
    return valuesString
        .split(',')
        .map(value => value.trim())
        .filter(value => value !== '');
};

// Check if attribute name already exists
export const attributeNameExists = (attributes, name, currentIndex = -1) => {
    if (!Array.isArray(attributes)) return false;
    
    const normalizedName = name.trim().toLowerCase();
    
    return attributes.some((attr, index) => 
        index !== currentIndex && 
        attr.name.trim().toLowerCase() === normalizedName
    );
};

// Validate attribute before adding/updating
export const validateAttribute = (attribute, attributes, currentIndex = -1) => {
    const errors = {};
    
    // Validate name
    if (!attribute.name || attribute.name.trim() === '') {
        errors.name = 'Attribute name is required';
    } else if (attributeNameExists(attributes, attribute.name, currentIndex)) {
        errors.name = 'An attribute with this name already exists';
    }
    
    // Validate values
    if (!attribute.values || 
        (typeof attribute.values === 'string' && attribute.values.trim() === '') ||
        (Array.isArray(attribute.values) && attribute.values.length === 0)) {
        errors.values = 'At least one attribute value is required';
    }
    
    return {
        isValid: Object.keys(errors).length === 0,
        errors
    };
};